import RingSearch from '../../src/legacy/RingSearch.tsx';
export default RingSearch;
